module.exports = __webpack_public_path__ + "img/yan.d883e9d6.png";